<template>
  <div class="search-filter-nlq">
    <v-textarea
      v-model="nlqQuery"
      rows="1"
      auto-grow
      light
      label="NLQ"
      solo-inverted
      hide-details
      clearable
      dense
      class="search-box"
      prepend-inner-icon="fas fa-search"
      @keydown="handleKeyDownKeywords"
      @click:clear="handleClickClearKeywords"
    ></v-textarea>
    <div class="nlq-input-warning" v-if="specialCharactersRule">
      {{ specialCharactersRule }}
    </div>
    <div class="nlq-error" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="nlq-feedback mt-2" v-if="getFeedback">
      <FeatureFeedback
        type="nlq"
        :metadata="feedbackMetadata"
        :lastReset="lastReset"
        @clear-feedback="getFeedback = false"
      />
    </div>
    <Loader v-if="loading" text="" color="black" class="mt-3" />
  </div>
</template>

<script>
import lodashDebounce from "lodash/debounce";

import { EVENT_ACTIONS, SEARCH_CATEGORIES } from "@/common/constants/analytics";
import { processNLQ } from "@/services/search/nlq.service";

const EMITTED_ACTIONS = {
  LOAD_NLQ_PARAMS: "load-nlq-params",
};

export default {
  name: "SearchNLQ",
  components: {
    Loader: () => import("@/components/common/Loader"),
    FeatureFeedback: () => import("@/components/common/FeatureFeedback"),
  },
  props: {
    lastReset: {
      type: String,
      default: new Date().toISOString(),
    },
  },
  data: function () {
    return {
      nlqQuery: "",
      loading: false,
      errorMessage: null,
      getFeedback: false,
      feedbackMetadata: null,
    };
  },
  computed: {
    specialCharactersRule() {
      if (
        this.nlqQuery?.indexOf("@") > -1 ||
        this.nlqQuery?.indexOf("#") > -1
      ) {
        return "Non-functional special character detected.";
      }
      return false;
    },
  },
  methods: {
    reset() {
      this.nlqQuery = "";
      this.loading = false;
      this.errorMessage = null;
      this.getFeedback = false;
    },
    async loadNLQParams() {
      if (this.nlqQuery.length) {
        try {
          this.loading = true;
          this.errorMessage = null;

          const params = await processNLQ(this.nlqQuery);
          if (params) {
            this.feedbackMetadata = {
              query: this.nlqQuery,
              response: params,
            };
            this.handlePageTrackerEvent(
              SEARCH_CATEGORIES.live_search_nlq,
              EVENT_ACTIONS.success,
              "Query: " +
                this.nlqQuery +
                " ;Response: " +
                JSON.stringify(params)
            );
            await this.$emit(EMITTED_ACTIONS.LOAD_NLQ_PARAMS, params);
            lodashDebounce(() => {
              this.getFeedback = true;
              this.nlqQuery = "";
              this.loading = false;
            }, 10)();
          } else {
            this.loading = false;
            this.errorMessage =
              "There was an issue processing query, please try again.";
            throw "no response";
          }
        } catch (error) {
          this.handlePageTrackerEvent(
            SEARCH_CATEGORIES.live_search_nlq,
            EVENT_ACTIONS.failed,
            "Query: " + this.nlqQuery + " ;Error: " + error
          );
        }
      }
    },
    handleKeyDownKeywords(event) {
      if (event.keyCode === 13) {
        event.preventDefault(); //so text doesn't get new line on enter
        this.loadNLQParams();
      } else {
        this.errorMessage = null;
        this.getFeedback = false;
        this.feedbackMetadata = null;
      }
    },
    handleClickClearKeywords() {
      this.nlqQuery = "";
      this.errorMessage = null;
      this.getFeedback = false;
      this.feedbackMetadata = null;
    },
  },
  watch: {
    lastReset: {
      handler() {
        //Reset when parent components change the reset timestamp
        this.reset();
      },
    },
  },
};
</script>
<style scoped>
.nlq-input-warning {
  color: red;
  font-size: x-small;
}
.nlq-error {
  color: red;
  font-size: small;
}
</style>
